import React, { Component } from "react";
import anime from "animejs";
import _ from "lodash";
import { Motion, spring } from "react-motion";
import { BackgroundImage, Star } from "../../components";
import { withRedux } from "../../hoc";

const background = `${process.env.PUBLIC_URL}/assets/images/section-1/background.jpg`;
const person4Img = `${process.env.PUBLIC_URL}/assets/images/section-1/person-4.png`;
const pattayaImg = `${process.env.PUBLIC_URL}/assets/images/section-1/pattaya.png`;
const houseImg = `${process.env.PUBLIC_URL}/assets/images/section-1/house.png`;
const person2Img = `${process.env.PUBLIC_URL}/assets/images/section-1/person-2.png`;
const person3Img = `${process.env.PUBLIC_URL}/assets/images/section-1/person-3.png`;
const feather10Img = `${process.env.PUBLIC_URL}/assets/images/section-1/feather-10.png`;
const person1Img = `${process.env.PUBLIC_URL}/assets/images/section-1/person-1.png`;
const starImg = `${process.env.PUBLIC_URL}/assets/images/star2.png`;
const feather9Img = `${process.env.PUBLIC_URL}/assets/images/section-1/feather-9.png`;
const feather8Img = `${process.env.PUBLIC_URL}/assets/images/section-1/feather-8.png`;
const feather5Img = `${process.env.PUBLIC_URL}/assets/images/section-1/feather-5.png`;
const feather4Img = `${process.env.PUBLIC_URL}/assets/images/section-1/feather-4.png`;
const feather3Img = `${process.env.PUBLIC_URL}/assets/images/section-1/feather-3.png`;
const feather2Img = `${process.env.PUBLIC_URL}/assets/images/section-1/feather-2.png`;
const logoWithText = `${process.env.PUBLIC_URL}/assets/images/logo-with-text.png`;
const mobileBg = `${process.env.PUBLIC_URL}/assets/images/section-1/mobile/mobile-bg.png`;
const mobileFeather2 = `${process.env.PUBLIC_URL}/assets/images/section-1/mobile/mobile-feather2.png`;
const mobilePerson1 = `${process.env.PUBLIC_URL}/assets/images/section-1/mobile/mobile-person1.png`;
const mobilePerson2 = `${process.env.PUBLIC_URL}/assets/images/section-1/mobile/mobile-person2.png`;
const mobilePerson3 = `${process.env.PUBLIC_URL}/assets/images/section-1/mobile/mobile-person3.png`;
const mobileFeather4 = `${process.env.PUBLIC_URL}/assets/images/section-1/mobile/mobile-feather4.png`;

const springConfig = { stiffness: 80, damping: 26 };
const animateStep = {
  1: {
    opacity: [{ value: 0 }, { value: 1, duration: 2500, easing: "easeInOutQuad" }],
    offset: 0
  },
  2: {
    opacity: [{ value: 0 }, { value: 1, duration: 2000, easing: "easeInOutQuad" }],
    translateY: [{ value: -10 }, { value: 0, duration: 1500, easing: "easeInOutQuad" }],
    offset: 200
  },
  3: {
    opacity: [{ value: 0 }, { value: 1, duration: 1500, easing: "easeInOutQuad" }],
    translateY: [{ value: 10 }, { value: 0, duration: 1500, easing: "easeInOutQuad" }],
    scale: [{ value: 0.95 }, { value: 1, duration: 1500, easing: "easeInOutQuad" }],
    offset: 1000
  },
  4: {
    opacity: [{ value: 0 }, { value: 1, duration: 1500, easing: "easeInOutQuad" }],
    translateY: [{ value: 10 }, { value: 0, duration: 1500, easing: "easeInOutQuad" }],
    scale: [{ value: 0.9 }, { value: 1, duration: 1500, easing: "easeInOutQuad" }],
    offset: 2000
  }
};

const ParentStar = React.forwardRef((props, ref) => <Star parent={ref} />);

const mapStateToProps = ({ language, t }) => {
  return {
    language,
    t
  };
};

const actionToProps = {};

@withRedux(mapStateToProps, actionToProps)
export default class Section1 extends Component {
  constructor(props) {
    super(props);
    this.section1Ref = React.createRef();
    this.centerX = window.innerWidth * 0.5;
    this.centerY = window.innerHeight * 0.5;
  }
  state = {
    dx: 0,
    dy: 0,
    animateCompleted: false
  };
  componentDidMount() {
    this.doAnimate();
    setInterval(this.randomMousePosition, 1000);
    window.addEventListener("mousemove", this.handleMousemove);
  }
  componentWillUnmount() {
    window.removeEventListener("mousemove", this.handleMousemove);
  }
  randomMousePosition = () => {
    if (!this.state.animateCompleted) return;
    this.setState({
      dx: this.state.dx + _.random(-100, 100),
      dy: this.state.dy + _.random(-400, 400)
    });
  };
  handleMousemove = e => {
    const dx = this.centerX - e.clientX;
    const dy = this.centerY - e.clientY;
    if (!this.state.animateCompleted) return;
    this.setState({ dx, dy });
  };
  doAnimate = () => {
    const basicTimeline = anime.timeline({
      complete: anim => {
        this.setState({ animateCompleted: true });
      }
    });
    basicTimeline
      .add({
        targets: this.section1Ref.current.querySelector(".group"),
        ...animateStep[1]
      })
      .add({
        targets: this.section1Ref.current.querySelector(".person-1"),
        ...animateStep[2]
      })
      .add({
        targets: this.section1Ref.current.querySelector(".person-2"),
        ...animateStep[3]
      })
      .add({
        targets: this.section1Ref.current.querySelector(".person-3"),
        ...animateStep[3]
      })
      .add({
        targets: this.section1Ref.current.querySelector(".house"),
        ...animateStep[3]
      })
      .add({
        targets: this.section1Ref.current.querySelector(".light-house"),
        ...animateStep[3]
      })
      .add({
        targets: this.section1Ref.current.querySelector(".person-4"),
        ...animateStep[3]
      })
      .add({
        targets: this.section1Ref.current.querySelector(".logo-with-text"),
        ...animateStep[3]
      });
  };
  render() {
    const { dx, dy } = this.state;
    const style = {
      dx: spring(dx, springConfig),
      dy: spring(dy, springConfig)
    };
    return (
      <div className="section-1" ref={this.section1Ref}>
        <div className="desktop-size">
          <Motion style={style}>
            {iStyle => (
              <React.Fragment>
                <div className="group">
                  <BackgroundImage
                    className="background"
                    image={background}
                    width="105%"
                    style={{
                      transformOrigin: "50% 50%",
                      transform: `
                      rotateX(${0.005 * iStyle.dx}deg)
                      rotateY(${-0.01 * iStyle.dx}deg)
                      translate(${iStyle.dx * -0.01}px, ${iStyle.dy * 0}px)
                    `
                    }}
                  />
                  <ParentStar ref={this.section1Ref} />
                  <img
                    className="person-4"
                    src={person4Img}
                    alt=""
                    style={{ transform: `translate(${iStyle.dx * 0.0005}px, ${iStyle.dy * 0}px)` }}
                  />
                  <img className="pattaya" src={pattayaImg} alt="" />
                  <div className="light-house" />
                  <img className="house" src={houseImg} alt="" />
                  <img className="person-2" src={person2Img} alt="" />
                  <img
                    className="person-3"
                    src={person3Img}
                    alt=""
                    style={{
                      transform: `translate(${iStyle.dx * 0.003}px, ${iStyle.dy * 0.003}px)`
                    }}
                  />
                  <img className="feather-10" src={feather10Img} alt="" />
                  <img
                    className="person-1"
                    src={person1Img}
                    alt=""
                    style={{
                      transform: `translate(${iStyle.dx * 0.01}px, ${iStyle.dy * 0.005}px)`
                    }}
                  />
                  <img className="light-earring" src={starImg} alt="" />
                  <img className="feather-9" src={feather9Img} alt="" />
                  <img
                    className="feather-8"
                    src={feather8Img}
                    alt=""
                    style={{
                      transform: `translate(${iStyle.dx * 0.01}px, ${iStyle.dy * 0.002}px)`
                    }}
                  />
                  <img className="feather-5" src={feather5Img} alt="" />
                  <img className="feather-4" src={feather4Img} alt="" />
                  <img className="feather-3" src={feather3Img} alt="" />
                  <img
                    className="feather-2"
                    src={feather2Img}
                    alt=""
                    style={{
                      transform: `translate(${iStyle.dx * 0.005}px, ${iStyle.dy * 0.002}px)`
                    }}
                  />
                  <img
                    className="logo-with-text"
                    src={logoWithText}
                    alt=""
                    style={{
                      transform: `translate(${iStyle.dx * 0.005}px, ${iStyle.dy * 0.005}px)`
                    }}
                  />
                </div>
              </React.Fragment>
            )}
          </Motion>
        </div>
        <div className="mobile-size">
          <BackgroundImage image={mobileBg} position="right" />
          <img className="mobile-person1" src={mobilePerson1} alt="" />
          <img className="mobile-person2" src={mobilePerson2} alt="" />
          <img className="mobile-person3" src={mobilePerson3} alt="" />
          <img className="mobile-feather2" src={mobileFeather2} alt="" />
          <img className="mobile-logo" src={logoWithText} alt="" />
          <img className="mobile-feather1" src={mobileFeather4} alt="" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/Section1.js